import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getGroupsForDropdown,
  getFactoryByGroupID,
  getAllRequisionsByFactoryID,
  getSKUByFactoryID,
  getAllActiveItemCategory,
  getItemsByfactoryIDItemCategoryID,
  GetSuppliersByItemIDAndFactoryID,
  SaveQuotationDetails,
  DeleteBinDetails,
  GetRequisitionNumbers,
  GetItemsByRequisitionFactoryID,
  GetItemsQuantityByItem,
  GetAllQuotationDetails,
  GetSuppliersByItem,
  uploadSelectedRequisitions,
  getStatus,
  getQuotationDetails,
  getAllFactoriesByGroupID
};

async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getFactoryByGroupID(groupID){
    let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    const factoryArray = [];
    const data = response?.data ?? [];
    if (Array.isArray(data)) {
        for (const item of data) {
            factoryArray.push({
                id: item.factoryID,
                name: item.factoryName
            });
        }
    } else {
        for (const [, item] of Object.entries(data)) {
            factoryArray.push({
                id: item.factoryID,
                name: item.factoryName
            });
        }
    }
    return factoryArray;
}
async function getAllFactoriesByGroupID(groupID) {
    let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    const factoryArray = [];
    const data = response?.data ?? [];
    if (Array.isArray(data)) {
        for (const item of data) {
            factoryArray.push({
                id: item.factoryID,
                name: item.factoryName
            });
        }
    } else {
        for (const [, item] of Object.entries(data)) {
            factoryArray.push({
                id: item.factoryID,
                name: item.factoryName
            });
        }
    }
    return factoryArray;
}

async function getAllRequisionsByFactoryID(factoryID) {
  let response = await CommonGet('/api/Quotation/GetRequisitionNumbers', 'factoryID=' + parseInt(factoryID));
  return response.data;
}

async function getSKUByFactoryID(groupID) {
  let response = await CommonGet('/api/Quotation/GetSKUByFactoryID', 'groupID=' + parseInt(groupID));
  return response.data;
}

async function getAllActiveItemCategory() {
  const response = await CommonGet('/api/ItemMasterData/GetAllItemCategory', null);
  let categoryArray = [];
  for (let item of Object.entries(response.data)) {
    categoryArray[item[1]["itemCategoryID"]] = item[1]["categoryName"]
  }
  return categoryArray;
}

async function getItemsByfactoryIDItemCategoryID(GardenID, ItemCategoryID) {
  const response = await CommonGet('/api/ItemMasterData/GetItemsByfactoryIDItemCategoryID', "GardenID=" + parseInt(GardenID) + "&ItemCategoryID=" + parseInt(ItemCategoryID));
  let itemArray = [];
  for (let item of Object.entries(response.data)) {
    itemArray[item[1]["itemID"]] = item[1]["itemName"];
  }
  return itemArray;
}

async function GetSuppliersByItemIDAndFactoryID(GardenID) {
  var supplierArray = [];
  const response = await CommonGet('/api/ItemMasterData/GetSuppliersByItemIDAndFactoryID', "GardenID=" + parseInt(GardenID));
  for (let item of Object.entries(response.data)) {
    supplierArray[item[1]["supplierID"]] = item[1]["supplierName"];
  }
  return supplierArray;
}

async function SaveQuotationDetails(saveModel) {
  const response = await CommonPost('/api/QuotationDetails/SaveQuotationDetails', null, saveModel);
  return response;
}

async function GetAllQuotationDetails(model) {
  const response = await CommonPost('/api/Quotation/GetQuotationCall', null, model);
  return response;
}

async function DeleteBinDetails(quotationID) {
  const response = await CommonGet('/api/QuotationDetails/DeleteQuotationDetails', 'quotationID=' + parseInt(quotationID));
  return response;
}
async function GetRequisitionNumbers(factoryID) {
  const response = await CommonGet('/api/Quotation/GetRequisitionNumbers', 'EstateID=' + parseInt(factoryID))
  let data = response.data;
  return data;
}
async function GetSuppliersByItem(itemID, factoryID) {
  const response = await CommonGet('/api/Quotation/GetSuppliersByItem', 'skuMasterID=' + parseInt(itemID) + '&factoryID=' + parseInt(factoryID))
  let data = response.data;
  return data;
}

async function GetItemsByRequisitionFactoryID(requisition) {
  const response = await CommonGet('/api/Quotation/GetItemsByRequisitions', 'reuisitionNumber=' + parseInt(requisition))
  let itemArray = [];
  for (let item of Object.entries(response.data)) {
    itemArray.push({
      skuMasterID: item[1]["skuMasterID"],
      skuMasterName: item[1]["skuMasterName"]
    });
  }
  return itemArray;
}

async function GetItemsQuantityByItem(array, itemID) {
  let string = array.join(',');

  const response = await CommonGet('/api/Quotation/GetItemsQuantityByItem', 'reuisitionNumbers=' + (string) + "&ItemID=" + parseInt(itemID))
  return response.data;
}

async function uploadSelectedRequisitions(model) {
  const response = await CommonPost('/api/Quotation/SaveQuotation', null, model);
  return response;
}

async function getStatus() {
  let response = await CommonGet('/api/Quotation/GetStatus', null);
  let statusArray = [];
  for (let item of Object.entries(response.data)) {
    statusArray[item[1]["statuSID"]] = item[1]["statusName"];
  }
  return statusArray;
};

async function getQuotationDetails(groupID, factoryID, statusID, requisitionID) {
  const response = await CommonGet('/api/Quotation/GetQuotationDetails', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID) + "&statusID=" + parseInt(statusID) + "&requisitionID=" + parseInt(requisitionID));
  return response;
}